import type { SegmentationOperator } from '@/shared/types/segmentation';

export const OPERATOR_LABELS: Record<SegmentationOperator, string> = {
  equals: 'é igual a',
  not_equals: 'é diferente de',
  contains: 'contém',
  not_contains: 'não contém',
  starts_with: 'começa com',
  is_empty: 'está vazio',
  is_not_empty: 'não está vazio',
  gt: 'maior que',
  gte: 'maior ou igual a',
  lt: 'menor que',
  lte: 'menor ou igual a',
  between: 'entre',
  before: 'antes de',
  after: 'depois de',
  relative_last_n_days: 'nos últimos N dias',
  relative_more_than_n_days_ago: 'há mais de N dias',
  in: 'é um de',
  not_in: 'não é nenhum de',
  is_true: 'sim',
  is_false: 'não',
};

/** Operadores cujo campo de valor não faz sentido mostrar (a resposta já está no operador). */
export const OPERATORS_WITHOUT_VALUE: SegmentationOperator[] = ['is_empty', 'is_not_empty', 'is_true', 'is_false'];

/** Operadores que precisam de dois valores (min/max) em vez de um. */
export const OPERATORS_WITH_RANGE: SegmentationOperator[] = ['between'];

/** Recência em dias — input numérico, não date picker. */
export const OPERATORS_RELATIVE_DAYS: SegmentationOperator[] = [
  'relative_last_n_days',
  'relative_more_than_n_days_ago',
];
